import styled, { css } from "styled-components";
import tw from "twin.macro";

export default styled.button(() => [
  tw`flex px-1 h-3 space-x-0.5 items-center `,
  css`
    & span {
      font-size: 0.4rem;
    }
  `,
]);
